import Select2 from 'select2/dist/js/select2.min';

$(document).ready(() => {
    $('.box-select select').each(function () {
        $(this).select2({
            minimumResultsForSearch: Infinity,
            width: '100%',
            allowClear: false,
            dropdownParent: $(this).parent('.box-select')
        });
    });
});
